<div class="mt-3">
  <p-panel header="Order Reports" [toggleable]="true">
    <ng-template pTemplate="icons"> </ng-template>
    <div class="nav-link p-0 dropdown">
      <a
        class="link d-block pt-2 pb-2 text-decoration-none"
        routerLink="/reports/ready-to-bill"
        >Ready To Bill Report</a
      >

      <a
        *ngIf="!saleOrderListAdminStatus"
        class="link d-block pt-2 pb-2 text-decoration-none"
        routerLink="/reports/order-written-report-paginated"
        >Orders Written Report</a
      >
      <a
        *ngIf="saleOrderListAdminStatus"
        class="link d-block pt-2 pb-2 text-decoration-none"
        routerLink="/reports/order-written-report/admin"
        >Orders Written Report</a
      >

      <a
        class="link d-block pt-2 pb-2 text-decoration-none"
        routerLink="/reports/order-billed-invoiced"
        >Orders Billed/Invoiced Details Report</a
      >
    </div>
  </p-panel>
</div>

<div class="mt-3">
  <p-panel header="Client Reports" [toggleable]="true">
    <ng-template pTemplate="icons"> </ng-template>
    <div class="nav-link p-0 dropdown">
      <a
        class="link d-block pt-2 pb-2 text-decoration-none"
        routerLink="/reports/customer-aging-detail-report"
        >Client Aging Detail Report</a
      >

      <a
        class="link d-block pt-2 pb-2 text-decoration-none"
        routerLink="/reports/open-customer-invoices-report"
        >Open Customer Transactions</a
      >

      <a
        class="link d-block pt-2 pb-2 text-decoration-none"
        routerLink="/reports/open-client-credits"
        >Open Client Credits</a
      >

      <a
        class="link d-block pt-2 pb-2 text-decoration-none"
        routerLink="/reports/rpt-top-client"
        >Top Clients Report</a
      >

      <a
        *ngIf="loggedInUserIsAdmin || loggedInUserIsBC"
        class="link d-block pt-2 pb-2 text-decoration-none"
        routerLink="/reports/year-over-year"
        >Year Over Year (Beta)</a
      >
    </div>
  </p-panel>
</div>
